export const SET_NOTIFICATION_COUNT = 'SET_NOTIFICATION_COUNT';
export const RESET_UNREAD_NOTIFICATION = 'RESET_UNREAD_NOTIFICATION';
